import { Box } from '@mui/material';
import ApproveBeneficiaryComponentStyle from './ApproveBeneficiaryComponent.style';
import { AlertMessage } from './components/alertMessage';
import BeneficiaryCard from './components/beneficiaryCard';
import RemainingTime from './components/remainingTime';
import { ActionType, UpdateBeneficiaryServiceResponse } from './types';

type ApproveBeneficiaryComponentProps = {
  action: ActionType;
  showRemainingTime: boolean;
  error: boolean;
  beneficiaryData?: UpdateBeneficiaryServiceResponse | null;
};

const ApproveBeneficiaryComponent = ({
  action,
  showRemainingTime,
  error,
  beneficiaryData,
}: ApproveBeneficiaryComponentProps) => (
  <Box className={ApproveBeneficiaryComponentStyle.wrapper}>
    <AlertMessage action={error ? 'expire' : (action as ActionType)} />
    {showRemainingTime && <RemainingTime />}
    {beneficiaryData && (
      <Box className={ApproveBeneficiaryComponentStyle.container}>
        <BeneficiaryCard beneficiaryData={beneficiaryData} />
      </Box>
    )}
  </Box>
);

export default ApproveBeneficiaryComponent;
